import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useSettingsContext } from 'src/components/settings';

import { ModuleLayout } from '../module/layout';
import { useDivisionNavData } from '../config-nav-dashboard';
import { DivisionInfo } from './division-info';

// ----------------------------------------------------------------------

export type DivisionLayoutProps = {
  children: React.ReactNode;
};

export function DivisionLayout({ children }: DivisionLayoutProps) {
  const settings = useSettingsContext();
  const { divisionNavData } = useDivisionNavData();
  const location = useLocation();

  useEffect(() => {
    settings.onUpdateField('navLayout', 'mini');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Check if current route is create or edit
  const isCreateOrEdit = location.pathname.endsWith('/new') || location.pathname.endsWith('/edit');

  // For create/edit pages, render children without sidebar
  if (isCreateOrEdit) {
    return <>{children}</>;
  }

  // For other pages (overview, teams, groups, matches), render with sidebar
  return (
    <ModuleLayout data={divisionNavData} navTopComponent={<DivisionInfo />}>
      {children}
    </ModuleLayout>
  );
}
